import { render, staticRenderFns } from "./checkOrderResult.vue?vue&type=template&id=5054d9ea&scoped=true&"
import script from "./checkOrderResult.vue?vue&type=script&lang=js&"
export * from "./checkOrderResult.vue?vue&type=script&lang=js&"
import style0 from "./checkOrderResult.vue?vue&type=style&index=0&id=5054d9ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5054d9ea",
  null
  
)

export default component.exports